import "./Contact.css";
import ContactHero from "./ContactHero/ContactHero";
import ContactDetails from "./ContactDetails/ContactDetails";
import ContactForm from  "./ContactForm/ContactForm";
import ContactSteps from "./ContactSteps/ContactSteps";
import CreditreformPanel from "./CreditreformPanel/CreditreformPanel";
import SEO from "../../components/SEO/SEO";

function Contact() {
  return (
    <div className="contact-page-container">
          <>
          <SEO
            title="Kontakt | Fit2Clean"
            description="Kontaktieren Sie uns per Kontaktformular oder direkt per Telefon."
            canonical="https://www.fit-to-clean.de/contact"
          />

      <div className="contact-hero">
        <ContactHero
          eyebrow="Kontakt"
          title="Lassen Sie uns über Ihr Objekt sprechen"
          text="Ob Büro, Praxis oder komplette Gewerbefläche – schicken Sie uns kurz die wichtigsten Eckdaten und wir melden uns mit einem passenden Vorschlag."
        />
      </div>

      <section className="contact-layout fade-in-up">
        <div className="contact-layout-inner">
          <div className="contact-column contact-column--left">
            <ContactForm />
          </div>

          <div className="contact-column contact-column--right">
            <ContactSteps
              title="So läuft Ihre Anfrage ab"
              step1Title="Anfrage senden"
              step1Text="Sie beschreiben kurz Ihr Objekt, die Nutzung und gewünschte Reinigungsintervalle."
              step2Title="Rückruf & Einschätzung"
              step2Text="Wir melden uns persönlich, klären offene Fragen und besprechen das weitere Vorgehen."
              step3Title="Angebot erhalten"
              step3Text="Auf Basis Ihrer Angaben erhalten Sie ein transparentes, faires Angebot."
            />

            <ContactDetails
              company="Amira Schweiger"
              addressLines={["Seniweg 2", "82538 Geretsried"]}
              phone="08171 6971"
              mobile="0176 8430 5728"
              fax="08171 345340"
              email="info@fit-to-clean.de"
              note="Wir sind im gesamten MVV-Gebiet rund um München für Sie im Einsatz."
            />
          </div>
        </div>
      </section>

        <div className="creditreform">
          <CreditreformPanel />
        </div>

         </>
    </div>
  );
}

export default Contact;
